import dataConstants from '../constants';

export function data(state = { match: null }, action) {
    switch (action.type) {
        case dataConstants.SHOW_MANUAL_LOOKUP_DIALOG:
            return {
                ...state,
                manualLookupDialogContext: action.context,
                showManualLookupDialog: true
            };
        case dataConstants.HIDE_MANUAL_LOOKUP_DIALOG:
            return {
                ...state,
                showManualLookupDialog: false
            };
        case dataConstants.MANUAL_LOOKUP_REQUESTED:
            return {
                submitting: true,
                match: null
            };
        case dataConstants.MANUAL_LOOKUP_SUCCESS:
            return {
                submitting: false,
                match: action.match
            };
        case dataConstants.SHOW_MULTIPLE_MATCHES_DIALOG:
            return {
                submitting: false,
                matches: action.matches,
                manualLookupDialogContext: action.context,
                showMultipleMatchDialog: true
            };
        case dataConstants.HIDE_MULTIPLE_MATCHES_DIALOG:
            return {
                submitting: false,
                matches: action.matches,
                showMultipleMatchDialog: false,
                manualLookupDialogContext: action.context
            };
        default: return state;
    }
}